export const SITE_TITLE = 'Crafty Smile';
export const SITE_URL = 'https://craftysmile.com/';

/**
 * The time in milliseconds to wait before refreshing the firebase token.
 */
export const refreshTokenMs = 50 * 60 * 1000; // 50 minutes

export const DEFAULT_STRIPE_ROLE = 'free';

export const COOKIE_CONSENT_KEY = 'cookie_consent_accepted';
